import styled from "styled-components";

export const Container = styled.div`
  // height: 80vh;
  width: 100%;
  margin-bottom: 30px;
`;
export const Top = styled.div`
  display: flex;
  justify-content flex-start;
  margin-bottom: 30px;
  @media screen and (max-width: 480px) {
    margin-bottom: 0px;
  }
`;
export const Title = styled.p`
  font-weight: 400;
  font-size: 60px;
  line-height: 100px;
  letter-spacing: 0.3em;
  @media screen and (max-width: 480px) {
    font-size: 35px;
    line-height: 70px;
    padding-left: 5px;
  }
`;

export const Bottom = styled.div`
  // height: calc(80vh - 131px);
  display: flex;
  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const Left = styled.div`
  width: 50%;
  // height: 100%;
  display: flex;
  justify-content: center;
  // align-items: center;
  @media screen and (max-width: 480px) {
    width: 65%;
  }
`;

export const Form = styled.form`
  // height: 80%;
  position: relative;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const Item = styled.div`
  position: relative;
`;

export const InputGroup = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
`;

export const Right = styled.div`
  width: 50%;
  // height: 100%;
  display: flex;
  // margin-left: 40px;
  // justify-content: flex-end;
  // align-items: center;
  @media screen and (max-width: 480px) {
    width: 65%;
  }
`;

export const Main = styled.div`
  width: 50%;
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;
export const Icon = styled.div`
  cursor: pointer;
`;
export const Follow = styled.p`
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 24px;
  font-weight: 300;
  @media screen and (max-width: 480px) {
    font-size: 14px;
    font-weight: 500;
  }
`;
export const Social = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const UserTopic = styled.div``;
export const Question = styled.p`
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 300;
  @media screen and (max-width: 480px) {
    font-size: 14px;
    font-weight: 500;
  }
`;
export const Answer = styled.p`
  font-size: 14px;
  font-weight: 300;
  text-align: justify;
  text-justify: inter-word;
  @media screen and (max-width: 480px) {
    font-size: 10px;
    font-weight: 500;
  }
`;

export const Msg = styled.p`
  font-size: 12px;
  position: absolute;
  right: 0px;
  left: 0px;
  bottom: 8px;
  text-align: center;
  color: red;
  @media screen and (max-width: 480px) {
    font-size: 10px;
  }
`;
